// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.files-preview {
  width: 100%;
}
.files-preview ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.files-preview li {
  padding: 1.6rem 0;
  border-bottom: 1px solid #c4c4c4;
}
.files-preview > p {
  margin: 0;
  line-height: 1.5;
}

.files-uploaded-confirmation-text {
  display: block;
  width: 100%;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/DocumentUploadForm/FilesPreview/index.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;AADF;AAGE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AADJ;AAIE;EACE,iBAAA;EACA,gCAAA;AAFJ;AAKE;EACE,SAAA;EACA,gBAAA;AAHJ;;AAOA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;AAJF","sourcesContent":["@use '@Styles/variables';\n\n.files-preview {\n  width: 100%;\n\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  li {\n    padding: 1.6rem 0;\n    border-bottom: 1px solid variables.$greyColorForBorder;\n  }\n\n  > p {\n    margin: 0;\n    line-height: 1.5;\n  }\n}\n\n.files-uploaded-confirmation-text {\n  display: block;\n  width: 100%;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
